import React from "react";
import { Route, Redirect } from "react-router-dom";
import { profilesRoutesDictionary } from "../components/ProfilesRouting/profilesDictionaries";

const loginProtect: any = ({ component: LoginPageComponent, ...rest }) => {
  let profile: authUserInfo = JSON.parse(
    localStorage.getItem("authUser") || "{}"
  );
  let pathRedirect = profile?.currentProfile
    ? `/${profilesRoutesDictionary[profile.currentProfile.type]}/home`
    : undefined;

  return (
    <Route
      {...rest}
      render={(props) =>
        profile.currentProfile === undefined ? (
          <LoginPageComponent {...props} />
        ) : (
          <Redirect
            to={{ pathname: pathRedirect, state: { from: props.location } }}
          />
        )
      }
    />
  );
};

export default loginProtect;
